import { useEffect, useState } from 'react';

import useMixRecipe from 'hooks/useMixRecipe';

import type { MixRecipe, UseFetchMixRecipeReturn } from './types';

// The shared useMixRecipe hook exposes fetchMixRecipe + isLoading but does
// not retain the fetched payload between renders. This local wrapper holds
// the awaited result in component state so MixApplyPage can read it on
// subsequent renders, and uses a cancellation flag to avoid setting state
// after the effect has been re-run or the component has unmounted.
const useFetchMixRecipe = (mixRecipeId: string | undefined): UseFetchMixRecipeReturn => {
    const [mixRecipe, setMixRecipe] = useState<MixRecipe | null>(null);
    const { fetchMixRecipe, isLoading } = useMixRecipe();

    useEffect(() => {
        if (!mixRecipeId) {
            return;
        }
        let cancelled = false;

        (async () => {
            const result = await fetchMixRecipe({ id: mixRecipeId });

            if (!cancelled) {
                setMixRecipe(result);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [fetchMixRecipe, mixRecipeId]);

    return { isLoading, mixRecipe };
};

export default useFetchMixRecipe;
